import classes from './Textarea.module.css';

const Textarea = (props) => {
  const { attribute, classList = [] } = props;
  const className = `${classes.Textarea} ${classList
    .map((item) => classes[item])
    .join(' ')}`;

  return (
    <div className={className}>
      <textarea
        {...attribute}
        value={attribute.value === null ? '' : attribute.value}
        className={classes['Textarea__Input']}
      ></textarea>
    </div>
  );
};

export default Textarea;
